import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 12h-6","key":"svg-0"}],["path",{"d":"M2 12h6","key":"svg-1"}],["path",{"d":"M8 7l8 5l-8 5l0 -10","key":"svg-2"}],["path",{"d":"M16 7v10","key":"svg-3"}]]

const IconCircuitDiode = createReactComponent('outline', 'circuit-diode', 'CircuitDiode', __iconNode);

export default IconCircuitDiode;